import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';

interface PdfChipGroupProps {
	children: React.ReactNode,
}

const styles = StyleSheet.create({
	chipGroup: {
		display: 'flex',
		flexWrap: 'wrap',
		flexDirection: 'row',
		gap: 4,
	},
});

const PdfChipGroup = (props: PdfChipGroupProps) => {
	const {
		children,
	} = props;

	return (
		<View style={styles.chipGroup}>
			{children}
		</View>
	);
};

export default PdfChipGroup;
